function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Avatar INSTEAD.
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from "../../../Display/Icon";
var UUAvatar = function UUAvatar(_ref) {
  var id = _ref.id,
    className = _ref.className,
    image = _ref.image,
    alt = _ref.alt,
    size = _ref.size,
    fallbackIcon = _ref.fallbackIcon;
  var _useState = useState(image ? 'loaded' : 'loading'),
    _useState2 = _slicedToArray(_useState, 2),
    imageStatus = _useState2[0],
    setImageStatus = _useState2[1];
  var handleImageLoaded = function handleImageLoaded() {
    setImageStatus('loaded');
  };
  var commonClasses = 'rounded-lg m-0.75 bg-inherit overflow-hidden inline-block';
  var avatarClass = classNames(commonClasses, {
    'bg-dark-fill-blue bg-gradient-to-r from-dark-fill-blue via-light-border-blue to-dark-fill-blue bg-no-repeat bg-scroll bg-200%': imageStatus === 'loading' && !fallbackIcon
  }, className);
  var sizeClass = useMemo(function () {
    switch (size) {
      case 'lg':
        return 'h-20 w-20 rounded-xl';
      case 'sm':
        return 'h-9 w-9 rounded-7';
      default:
        return 'h-60 w-11';
    }
  }, [size]);
  var iconClass = useMemo(function () {
    if (fallbackIcon && !image) {
      return 'h-9/10 w-9/10';
    }
    return '';
  }, [fallbackIcon, image]);
  return /*#__PURE__*/React.createElement("figure", {
    id: id,
    "data-role": "avatar",
    className: classNames(avatarClass, sizeClass)
  }, /*#__PURE__*/React.createElement("img", {
    className: fallbackIcon && !image ? 'hidden' : 'h-full',
    alt: alt,
    src: image,
    onLoad: handleImageLoaded
  }), fallbackIcon && !image && /*#__PURE__*/React.createElement(Icon, {
    icon: fallbackIcon,
    alt: alt,
    className: classNames(avatarClass, sizeClass, iconClass)
  }));
};
UUAvatar.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  fallbackIcon: PropTypes.string,
  id: PropTypes.string,
  image: PropTypes.string,
  size: PropTypes.oneOf(['lg', 'sm'])
};
UUAvatar.defaultProps = {
  alt: 'Avatar Image',
  className: '',
  fallbackIcon: null,
  id: '',
  image: '',
  size: ''
};
export default UUAvatar;